module.exports = __webpack_public_path__ + "media/images/result_sets/circles/2n1n4r8n-95b3ad5140bfe8333792602704499649.svg";